/** Kleine Anzeige-Vorlieben im Browser merken (Filter, auf- oder zugeklappt). Fällt ohne Speicher still auf den Standard zurück. */
import { useState } from 'react';

export function usePref<T>(key: string, init: T): [T, (v: T) => void] {
  const [v, setV] = useState<T>(() => { try { const r = localStorage.getItem(key); return r == null ? init : (JSON.parse(r) as T); } catch { return init; } });
  return [v, (n: T) => { setV(n); try { localStorage.setItem(key, JSON.stringify(n)); } catch { /* privater Modus */ } }];
}
